import React, { useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin as GoogleOAuthLogin } from '@react-oauth/google';
import { useAuth } from '../../context/AuthContext';

const GoogleLogin: React.FC = () => {
  const { login, loginWithPassword, isLoading } = useAuth();
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handlePasswordSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) return;
    setSubmitting(true);
    try {
      await loginWithPassword(email, password);
    } catch {
      // AuthContext already alerted
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="max-w-md w-full px-6">
          {/* Brand */}
          <div className="text-center mb-12">
            <h1 className="font-display text-5xl font-bold text-forest mb-3">
              MagicMetrics
            </h1>
            <p className="text-graphite text-lg">Nurture</p>
            <div className="w-24 h-1 bg-forest mx-auto mt-4"></div>
          </div>

          {/* Login Card */}
          <div className="bg-warm-white border border-sketch rounded-xl p-8 shadow-sketch">
            <h2 className="font-display text-2xl text-charcoal mb-2">Welcome</h2>
            <p className="text-graphite mb-8">
              Sign in to manage leads and site visits
            </p>

            {/* Google */}
            <div className="flex justify-center">
              <GoogleOAuthLogin
                onSuccess={async (credentialResponse) => {
                  if (credentialResponse.credential) {
                    await login(credentialResponse.credential);
                  }
                }}
                onError={() => {
                  console.log('Login Failed');
                }}
                theme="outline"
                size="large"
                text="signin_with"
                shape="rectangular"
              />
            </div>

            {/* Divider */}
            <div className="flex items-center gap-3 text-xs text-graphite my-6">
              <div className="flex-1 h-px bg-charcoal/10" />
              <span>or</span>
              <div className="flex-1 h-px bg-charcoal/10" />
            </div>

            {/* Email + password */}
            <form onSubmit={handlePasswordSubmit} className="space-y-3">
              <input
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="w-full px-3 py-2 border border-sketch rounded-lg text-sm focus:outline-none focus:border-forest"
                required
              />
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className="w-full px-3 py-2 border border-sketch rounded-lg text-sm focus:outline-none focus:border-forest"
                required
              />
              <button
                type="submit"
                disabled={submitting || isLoading || !email || !password}
                className="w-full bg-forest text-warm-white py-2 rounded-lg text-sm font-medium hover:bg-forest/90 transition-colors disabled:opacity-50"
              >
                {submitting ? 'Signing in…' : 'Sign in with email'}
              </button>
            </form>

            <p className="text-xs text-graphite text-center mt-8">
              By signing in, you agree to our Terms of Service and Privacy Policy
            </p>
          </div>

          {/* Footer */}
          <p className="text-center text-graphite text-sm mt-8">
            Premium. Exclusive. Trust.
          </p>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default GoogleLogin;
